import { Component } from '@angular/core';
import { ConfigDataProvider } from '../../providers/config-data/config-data';
import { ModalController } from 'ionic-angular';

@Component({
	selector: 'user-avatar',
	templateUrl: 'user-avatar.html'
})
export class UserAvatarComponent {

	private isDisabled: Boolean = false;

	constructor(
		private configDataPrvdr: ConfigDataProvider,
		private mdlCtrl: ModalController
	) {

	}

	openUserProfile() {

		this.isDisabled = true;

		const userModal = this.mdlCtrl.create("UserProfilePage", {}, {
			cssClass: 'user-profile-wrapper'
		});

		userModal.present();

		userModal.onDidDismiss(() => {
			this.isDisabled = false;
		})

	}

}



// WEBPACK FOOTER //
// ./src/components/user-avatar/user-avatar.ts